import React from "react";
import { useStyle } from "../../context/StyleProvider";
import { SUBSCRIPTION_PLANS_STARTING } from "../../../constants";
import { notFalsy } from "../../../../common/util";

export const StructuredData: React.FC = () => {
  const { style, buyInformation, rentalInformation, subscriptionInformation, isAlwaysNew } = useStyle();

  const url = `https://www.glamcorner.com.au${style.url}`;

  // All the image URL that have no visibility rules
  const images = style.image_info?.gallery
    .filter((galleryItem) => galleryItem.visibility_rules === null)
    .map((galleryItem) => galleryItem.url_by_size_and_pixel_density.large.x3)
    .map((imageUrl) => {
      // Remove the transform query parameters
      const url = new URL(imageUrl);
      url.search = "";
      return url.toString();
    });

  const toPrice = (priceInCents: number | null | undefined) => {
    if (priceInCents) {
      return (priceInCents / 100).toFixed(2);
    }
    return null;
  };

  const priceOffers = [];
  if (buyInformation) {
    const buyPrices = buyInformation.prices;

    priceOffers.push(buyPrices.buyPriceInCents);
    priceOffers.push(buyPrices.discountBuyPriceInCents);
  }
  if (rentalInformation) {
    rentalInformation.prices.forEach((prices) => {
      priceOffers.push(prices.priceInCents);
      priceOffers.push(prices.discountPriceInCents);
    });
  }
  if (subscriptionInformation) {
    priceOffers.push(SUBSCRIPTION_PLANS_STARTING * 100);
  }

  const sortedPrices = priceOffers.filter(notFalsy).sort((a, b) => b - a); // By default sort() sorts as STRINGS! >:C
  const lowestPrice = sortedPrices[sortedPrices.length - 1];
  const highestPrice = sortedPrices[0];

  const isInStock = priceOffers.length !== 0;

  const data = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "@id": url,
    name: style.name,
    image: images,
    description: style.description,
    sku: style.style_code,
    mpn: style.style_code,
    brand: {
      "@type": "Brand",
      name: style.designer,
    },
    offers: {
      "@type": "AggregateOffer",
      lowPrice: toPrice(lowestPrice),
      highPrice: toPrice(highestPrice),
      offerCount: priceOffers.length,
      priceCurrency: "AUD",
      itemCondition: isAlwaysNew ? "https://schema.org/NewCondition" : "https://schema.org/RefurbishedCondition",
      availability: isInStock ? "https://schema.org/InStock" : "https://schema.org/SoldOut",
    },
  };

  return (
    <script
      data-front-gateway="do-not-move" // FG moves so when react re-renders, it creates it again
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};
